// extracted by mini-css-extract-plugin
export default {"container":"oa","overlay":"pa","videoOverlay":"qa","header":"ra","close":"sa","content":"ta"};